import * as React from "react";
const SvgFiRrSunday = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sunday_svg__a)">
      <path
        fill="#062147"
        d="M19 2h-1V1a1 1 0 1 0-2 0v1H8V1a1 1 0 1 0-2 0v1H5C2.243 2 0 4.243 0 7v12c0 2.757 2.243 5 5 5a1 1 0 1 0 0-2c-1.654 0-3-1.346-3-3v-9h20v3a1 1 0 1 0 2 0V7c0-2.757-2.243-5-5-5M2 8V7c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v1zm15.992 8.784V21.7a2.3 2.3 0 0 1-2.539 2.288c-1.197-.122-2.06-1.22-2.06-2.422v-4.781a.8.8 0 1 1 1.6 0v4.916a.7.7 0 0 0 1.4 0v-4.916a.8.8 0 1 1 1.6 0zm6.008 0v6.23a.97.97 0 0 1-1.856.394L20.6 19.93v3.254a.8.8 0 1 1-1.6 0v-6.235a.97.97 0 0 1 1.856-.392l1.543 3.49v-3.263a.8.8 0 1 1 1.601 0m-11.334 5.165c-.191 1.175-1.215 2.028-2.436 2.028-.664 0-1.3-.195-1.839-.552a.733.733 0 0 1-.119-1.131.73.73 0 0 1 .888-.111c.316.191.688.297 1.069.297.604 0 1.031-.404 1.096-.795.088-.55-.602-.873-.817-.959-.915-.371-1.751-.78-1.753-.78-.692-.484-1.027-1.231-.921-2.049a2.17 2.17 0 0 1 1.471-1.796c.839-.277 1.603-.076 2.152.203a.727.727 0 0 1 .238 1.095l-.011.014a.695.695 0 0 1-.831.216c-.308-.138-.72-.237-1.156-.096-.412.136-.517.447-.516.577.005.442.335.57.433.615.282.128.806.368 1.366.595 1.461.591 1.828 1.745 1.685 2.627z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sunday_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSunday;
